export const TABS = {
  VOLUMES: "1",
  TEMPLATES: "2",
  FOLDERS: "3",
};

export const PAGE_SIZE = 8;
export const FOLDER_PAGE_SIZE = 6;

export const STATUS = {
  ACTIVE: "Active",
  SUSPENDED: "Suspended",
  DRAFT: "Draft",
};

export const PERMISSIONS = {
  FACULTY: "Faculty",
  OPENFACULTY: "OpenFaculty",
  STUDENTS: "Students",
  OPENSTUDENTS: "OpenStudents",
  ALL: "All",
};
